/**
 * Планирование фоновой работы в простое браузера — общий хелпер (был
 * приватным в assistant.ts, план 24.09 п.1 вытащил его наружу для прогрева
 * аварийных чанков без сети: тот же приём, второе место не изобретает своё).
 * `requestIdleCallback` есть не везде (Safari/iOS) — фолбэк на `setTimeout`.
 */
export function scheduleIdle(run: () => void, timeoutMs?: number): void {
  if ('requestIdleCallback' in window) {
    ;(
      window as Window & {
        requestIdleCallback: (cb: () => void, opts?: { timeout: number }) => void
      }
    ).requestIdleCallback(run, timeoutMs === undefined ? undefined : { timeout: timeoutMs })
  } else {
    setTimeout(run, timeoutMs ?? 2500)
  }
}
